// extracted by mini-css-extract-plugin
export var podcastEmbed = "self-studies-podcast-module--podcastEmbed--a5a13";